import { L } from "./abpUtility"

// ROLE

export enum AccountTypeEnum {
  AGENCY = "AGENCY",
  STAFF = "STAFF",
  CLIENT = "CLIENT",
}

export enum roleEnum {
  SalesAgencyRole = "Sales Agency",
  SalesAdminRole = "Supper User",
  ClientRole = "Client",
}

export enum ModuleEnum {
  FEEDBACK = 20,
  HANDOVER_PLAN = 50,
  CUSTOMER = 121,
  BOOKING = 122,
  UNIT = 123,
  AGENCYMASTER = 124,
  CART = 125,
  BOOKING_INVITATION = 126,
  INQUIRY = 127,
  CART_PRODUCT = 128,
  EMPLOYEE = 129,
  CONTRACT = 130,
  FEE_NOTIFICATION = 140,
  MODULE_BOOKING_RECEIPT = 135, // phiếu thu booking
  MODULE_PLAN_RECEIPT = 136, // phiếu thu
  DISCOUNT_RECEIPT = 139, // phiếu thu chiết khấu
  BOOKING_RECEIPT_RETURN = 156, // phiếu thu hoàn tiền
  IMPORT_BOOKING_RECEIPT = 152, // phiếu import
  PINKBOOK = 141,
  RETURN_RECEIPT = 142,
  PAYMENT_SLIP = 143,
  ACCOUNTING_INTERGRATION=144,
  INVOICE_INTERGRATION=145,
  SALE_EVENT = 146,
  EXISTINGCUSTOMER = 148,
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values -- cùng module id backend với IMPORT_BOOKING_RECEIPT
  IMPORT_RECEIPT=152,
  IMPORT_ENTITY_CONTACT_INFO=157,
  IMPORT_UNIT_TYPE=159,
  IMPORT_PROPERTY_TYPE=158,
}

export enum OrderEnum {
  DESC = 1,
  ASC = 2,
}
export enum ExportFileTypeEnum {
  Pdf = 1,
  Word = 2,
  Excel = 3,
}

export enum ComparisonOperationsEnum {
  EQUALS = 1,
  NOTEQUALS = 2,
  CONTAINS = 3,
  NOTCONTAINS = 4,
  GREATERTHAN = 5,
  LESSTHAN = 6,
  BETWEEN = 7,
  BEFORE = 8,
  AFTER = 9,
}
export enum ColumnDataTypeEnum {
  STRING = 1,
  NUMBER = 2,
  DATETIME = 3,
  BOOLEAN = 4,
  DROPDOWN = 5,
  LOOKUP = 6,
}

export enum ActivityModuleEnum {
  CUSTOMER = 1,
  INQUIRY = 2,
  PROPOSAL = 3,
  CONTRACT = 4,
}
// report
export enum BookingReportTypeEnum {
  Day = 1,
  Week = 2,
  Month = 3,
  Year = 4,
}

// pink book
export enum PinkBookStatusEnum {
  ISDELAYED = 1,
  ISPROCESSING = 2,
  ISCOMPLTED = 3,
}
export enum PinkBookContractStatusEnum {
  ISDELAYED = 1,
  ISPROCESSING = 2,
  ISCOMPLTED = 3,
}

export enum SalesEventTypeEnum {
  ONLINE = 1,
  OFFLINE = 2,
}

// sale event
export enum SaleEventApprovalStatusEnum {
  ISWAITING = 1,
  ISAPPROVED = 2,
  ISREJECTED = 3,
  ISNEW = 4,
}

export enum SaleEventTypeEnum {
  AFTER_SALESEVENT = 1,
  IN_SALESEVENT = 2,
  BEFORE_SALESEVENT = 3,
}

export enum SaleEventStatusEnum {
  NONE = 1,
  INPROGRESS = 2,
  COMPLETE = 3,
}

export enum SaleEventBookingTicketStatusEnum {
  ISTICKETED = 1,
  ISNOTTICKETED = 0,
}

export enum SaleEventBookingSendEmailStatusEnum {
  ISEMAILED = 1,
  ISNOTEMAIL = 2,
}

export enum SaleEventHaveCheckinEnum {
  HAVE = 1,
  NOT_HAVE = 2,
}

export enum SaleEventBookingSendSmsStatusEnum {
  ISSMS = 1,
  ISNOTSMS = 2,
}
export enum PinkBookSendStatusEnum {
  SEND_FAILED = "F",
  SENT = "S",
  NOT_SEND = "N",
}

export enum PinkBookContractProductStatusEnum {
  NONE = 1,
  IN_PROCESS = 2,
  COMPLETED = 3,
  MANUAL_UPDATE = 4,
}
// HANDOVER
export enum EnumHandoverPlanStatus {
  SENT = 7,
  RECIEVED = 2,
  INPROGRESS = 3,
  CANCELLED = 4,
  COMPLETED = 5,
  WAITFORSEND = 6,
  SUBMITTED = 1,
}

export enum EnumHandoverNotifyStatus {
  SENT = 7,
  NONE = 6,
  INPROGRESS = 3,
}

export enum EnumHandoverEmailStatus {
  FAILED = 'F',
  NEW = 'N',
  INPROGRESS = 'I',
  SUCCESS = 'S',
}

export enum EnumHandoverReservationStatus {
  SUBMITTED = 1,
  HANDOVERFAIL = 4,
  COMPLETED = 5,
  NONE = 6,
}
// POTENTIAL CUSTOMER

export enum PurposeEnum {
  STAYED = 1,
  INVESTMENT = 2,
  STAYED_AND_INVESTMENT = 3,
}

export enum NecessaryLevelEnum {
  // cần gấp
  URGENT = 1,
  // dự dịnh
  PLAN = 2,
  // tham khảo
  REFERENCE = 3,
}

export enum CustomerPotentialTypeEnum {
  // Khách hàng mới
  NEW = 1,
  // Khách hàng hiện tại
  CURRENT = 2,
  // Khách hàng trung thành
  LOYAL = 3,
  // Khách hàng đã rời bỏ
  CHURNED = 4,
}

export enum CustomerStatus {
  NEW = 1,
  TAKINGCARE = 2,
  TRANSFER = 3,
}

export enum SaleEventBookingPickUnitStatusEnum {
  NONE = 1,
  SUCCESS = 3,
  FAILED = 2,
  RESELECT = 4,
}

export enum SaleEventSentNotificationEnum {
  NONE = 0,
  INPROCESS = 1,
  SUCCESS = 2,
  FAIL = 3,
}

export enum SaleEventBookingTemplateNotificationEnum {
  NOTIFICATION_JOIN_OFFLINE = 1,
  NOTIFICATION_JOIN_ONLINE = 2,
  NOTIFICATION_ARRANGE_TIME_START = 3,
  NOTIFICATION_TIME_END = 4,
  NOTIFICATION_CANCEL = 5,
  NOTIFICATION_BOOKING_CANCEL = 6,
}
// APPROVAL

export enum ApprovalModule {
  Contract = 1,
  ContractEvent = 2,
  Booking = 3,
  SalesPolicy = 4, //Chính sách bán hàng
  Unit = 5,
  Customer = 6,
}

export enum EnumPotentialCustomerActionType {
  SCHEDULE = 1,
  TASK = 2,
  CALL = 3,
}

// Tiền tố _{number}_ map theo ApprovalModule
export enum RequestTypeEnum {
  //  _2_ContractEvent = 1, // ContractEvent
  _1_Contract = 2, // hợp đồng
  // _3_BookingExtension = 3, // Booking
  _6_UpdateCustomer = 4, // cập nhật thông tin khách hàng
  _5_PricingApproval = 5, // Unit
  _3_CancelBooking = 6, // Booking
  _3_BookingToContract = 7, // Booking
  // _3_ChangeBookingUnit = 8, // Booking
  _4_CreateSalesPolicy = 9, // SalesPolicy

  _2_CancelDA = 10, // Contract Event
  _2_DaToSpa = 11,
  _2_DaToLTL = 12,
  _2_TranferDa = 13,
  _2_LTLCancel = 14,
  _2_SPACancel = 15,
  _2_LTLTransfer = 16,
  _2_SPATransfer = 17,
  _2_LTL2SPA = 18,
  _2_Discount = 19,
  _2_ChangePaymentTerm = 20,
  _2_InterestReduction = 21, // giảm lãi 
  // _3_SubmitPurchaseUNC = 21, // Duyệt UNC đặt mua
  // _3_SubmitDepositUNC = 22, // Duyệt UNC đặt cọc
}
//
export enum RequestStatusEnum {
  PENDING = 1,
  APPROVED = 2,
  REJECTED = 3,
  CANCELLED = 4,
  REVOKE_APPROVAL = 5,
  DRAF = 100,
}

// contract
export enum ContractTypeEnum {
  DA = 1,
  SPA = 2,
  LTL = 3,
}
export enum FeeGroupEnum {
  NET = 1,
  TAX = 2,
}
export enum ContractPhaseEnum {
  DA = 1, // Đã đặt cọc
  SPA = 2,
  LTL = 3,
  // ROIDeposit = 4,
  // ROISigning = 5,
  // ROITransfer = 6,
  // ROICancel = 7,
  // ROICancelDeposit = 8,
  // ROICancelTransfer = 9,
  // ROICancelSigning = 10,
}

export enum ContractEventTypeEnum {
  DACancel = 1,
  DA2SPA = 2,
  DA2LTL = 3,
  DATransfer = 4,
  SPACancel = 5,
  SPATransfer = 6, // Không chuyển được SPA to LTL (Chỉ được đổi thông tin khách hàng)
  LTLCancel = 7,
  LTLTransfer = 8,
  LTL2SPA = 9, // ĐỔI LOẠI HỢP ĐỒNG VÀ THÔNG TIN KHÁCH HÀNG (NẾU CÓ)
  Discount = 10,
  ChangePaymentTerm = 11,
  InterestReduction = 12, // giảm lãi 
}

// masterData

export enum UnitHandoverStatusEnum {
  NOT_READY = 1,
  READY = 2,
}
// customer
export enum CustomerActivityTypeEnum {
  CALL = 1,
  EMAIL = 2,
  // PROPOSAL = 3,
  SITEVISIT = 4,
  // RESERVATION = 5,
}

//

// Activity
export enum ActivityTypeEnum {
  Call = 1,
  Mission = 2,
  // Lịch hẹn
  Schedule = 3,
  Event = 4,
  SiteVisit = 5,
}

export enum ActivityStatusEnum {
  //Chưa bắt đầu
  NEW = 1,
  // Đang thực hiện
  INPROGRESS = 2,
  // Tạm hoãn
  HOLD = 3,
  // Hoàn thành
  COMPLETED = 4,
  // Đã huỷ bỏ
  CANCELED = 5,
}
export enum ActivityMissionTypeEnum {
  // Gửi báo giá chi tiết căn hộ/nhà đất (qua email, Zalo, SMS).
  ReportBySocial = 1,
  // Cập nhật bảng giá mới nhất từ chủ đầu tư.
  UpdatePricing = 2,
  // Gửi chính sách bán hàng, ưu đãi, quà tặng.
  SendPromotions = 3,
  // Gửi thông tin so sánh giữa các dự án/căn hộ để khách hàng lựa chọn.
  SendInfoCompare = 4,
  // Gửi brochure, mặt bằng dự án, hồ sơ pháp lý.
  SendInfoUnit = 5,
  // Gửi giấy tờ liên quan đến tiến độ thanh toán.
  SendInfoPayment = 6,
  // Gửi hợp đồng mẫu, phiếu cọc, thủ tục mua bán.
  SendProcedure = 7,
  // Hướng dẫn chuẩn bị hồ sơ vay ngân hàng (nếu có).
  PreparationGuide = 8,
  //Gửi lịch thanh toán chi tiết.
  SendPaymentScheduleDetail = 9,
}
export enum ProposalTypeEnum {
  Project = 1,
  Unit = 2,
}

export enum AddressTypeEnum {
  PERMANENT = 1,
  CURRENT = 2,
  SUB = 3,
}

export enum FinacialCapacityEnum {
  LOW = 1,
  NORMAL = 2,
  HIGHT = 3,
}

export enum CustomerTypeEnum {
  INDIVIDUAL = 1,
  CORPORATE = 2,
}

export enum CustomerGroupEnum {
  GOLDEN = 1,
  WHITELIST = 2,
  BLACKLIST = 3,
}

export enum CustomerGenderEnum {
  MEN = 1,
  WOMAN = 2
}

export enum GenderStaffEnum {
  MEN = 1,
  WOMAN = 2,
}

export enum LegalStatusEnum {
  LURC = 0,
}
export enum OwnerShipStatus {
  Perpetual = 0,
  _50Year = 1,
}
export enum MaritalStatusEnum {
  SINGLE = 1,
  MARRIED = 2,
  // UNKNOW = 3,
}
export enum CustomerTitleEnum {
  MR = 1,
  MS = 2,
  MRS = 3,
  MISS = 4,
  MRYOUNG = 5,
  UNCLE = 6,
  OTHER = 7,
}

export enum LeadReportStatusEnum {
  NEW = 1,
  CONTACTED = 2,
  QUALIFIED = 3,
  LOST = 4,
}

// Inquiry
export enum InquiryStatusEnum {
  New = 1,
  IdentifyNeeds = 2,
  InitialConsultation = 3,
  ProductIntroduction = 4,
  CustomerCare = 5,
  Quotation = 6,
  Reservation = 7,
  ContractSigning = 8,
  CancelRequest = 9,
}

//#region incom

export enum ContractFeeGroup {
  NET = 1,
  VAT = 2,
}
export enum PaymentMethodConst {
  CASH = 1, // Tiền mặt
  TRANSFER = 2, // Chuyển khoản
  // DEFAULT = 3, // Mặc định
}
export enum LineType {
  FEE = 1, // Dòng trả phí
  AnotherReceipt = 2, // Dòng phí thu khác
  CurrentReceipt = 3, // Phiếu thu hiện tại
}
export enum ContractInquiryStatus {
  COMPLETE = 0, // Đã hoàn thành
  CONFIRM = 1, // Đã xác nhận
  RETURN = 2, // Đã hoàn trả
}
export enum ContractFeeStatus {
  NONE = 0, // Chưa thanh toán
  INPROCESS = 1, // Đã thanh toán 1 phần
  COMPLETE = 2, // Đã thanh toán
}
export enum SendThankLetterStatus {
  NONE = 0, // Chưa gửi
  SENT = 1, // Đã gửi
}
export enum SyncStatus {
  NONE = 1, // Chưa đồng bộ
  INPROCESS = 2, // Đang đồng bộ
  COMPLETE = 3, // Đã đồng bộ
  FAIL = 4, // Thất bại
  WAITING_FOR_INVOICE = 5, // Chờ xuất hoá đơn
  COMPLETE_INVOICE = 6, // Đã xuất hoá đơn
}
//#endregion

//#region fee notification
export enum SendStatus {
  SUCCESS = 1, // Gửi thành công
  FAIL = 2, // Gửi thất bại
}
export enum PaymentStatus {
  NONE = 1, // Chưa thanh toán
  INPROCESS = 2, // Đã thanh toán 1 phần
  COMPLETE = 3, // Đã thanh toán
}
export enum FeeNotificationType {
  NOT_NOTIFIED = 1, // Chưa thông báo
  NOTIFIED = 2, // Thông báo phí
  REMINDER1 = 3, // Nhắc nhở 1
  REMINDER2 = 4, // Nhắc nhở 2
  OVERDUE = 5, // Thông báo trễ hạn
  THANKYOULETTER = 6, // Thư cảm ơn
}
export enum ChannelNotification {
  EMAIL = 1, // Kênh thông báo là email
  SMS = 2, // Kênh thông báo là SMS
  EMAILANDSMS = 3, // Kênh thông báo là cả Email và SMS
}
export enum NotificationStatus {
  NEW = 1, // Tạo mới
  READYTOSEND = 2, // Sẵn sàng để gửi
  SENDING = 3, // Đang gửi
  SENT = 4, // Đã gửi hoàn tất
  FAIL = 5, // Có thất bại
}
//#endregion

// Template
export enum NotificationMethodEnum {
  SMS = 1,
  EMAIL = 2,
  DocxEditor = 4,
}

// WORK FLOW
export enum WfFieldTypesEnum {
  TEXT = 0,
  NUMBER = 1,
  MONEY = 2,
  DATETIME = 3,
  LIST = 4,
}

// CART
export enum CartPriortyEnum {
  CART_DEPOSIT = 0,
  CART_BOOKING = 1,
}
export enum CartTypeEnum {
  IDENTIFICATION = 1,
  ORDER = 2,
}

export enum CartProductViewStatusEnum {
  AVAILABLE = 0,
  VISIBLE = 1,
  LOCK = 2,
}

export enum CartConfirmTimeTypeEnum {
  MINUTE = 0,
  HOUR = 1,
  DAY = 2,
  MONTH = 3,
}

export enum TIMEUNIT {
  MINUTES = 6,
  HOURS = 5,
  DAY = 1,
}
export enum CartBookingApprovalEnum {
  AUTO = 0,
  HANDMADE = 1,
}

export enum CartAllowPaymentEnum {
  ALL = 0,
  PRIORITIZE = 1,
}
export enum NotificationTypeEnum {
  // Sàn tạo đặt chỗ
  AgencyMaster_BookingCreated = 1,
  // Sàn yêu cầu huỷ đặt chỗ
  AgencyMaster_BookingCancelled = 2,
  // Chủ đầu tư phê duyệt đặt chỗ
  Staff_BookingApproved = 3,
  // Chủ đầu tư từ chối đặt chỗ
  Staff_BookingRejected = 4,
  // Chủ đầu tư phê duyệt yêu cầu huỷ
  Staff_BookingCancelApproved = 5,
  // Chủ đầu tư từ chối yêu cầu huỷ
  Staff_BookingCancelRejected = 6,
  // Khách hàng đặt chỗ chọn căn thành công
  Customer_ClientBookingUnitSelected = 7,
  // Đặt chỗ bị huỷ bởi CĐT ( sau duyệt)
  Customer_BookingCancelledByStaff = 8,
  // Đặt chỗ chọn căn thất bại
  Customer_BookingUnitSelectionFailed = 9,
  // Hết thoi gian chọn sản phẩm
  Customer_BookingUnitSelectionTimeExpired = 10,
  // Đã gỡ căn
  Customer_BookingClearUnit = 11,
  // Chọn lại unit
  Customer_BookingRetryPickUnit = 12,
  // Gửi link chọn căn
  Customer_SalesEventSendUrlPickProduct = 13,
}

export enum CartNotificationAgencyMasterEnum {
  All = 1,
  AgencyMasterManager = 2,
  BookingCreator = 3,
}
// SALE POLICY
export enum PaymentScheduleTypeEnum {
  DAY = 1,
  MONTH = 2,
}
export enum SalesPolicyTypeEnum {
  Normal = 1,
  Special = 2,
}
//#region BOOKING

// export enum BookingStatusEnum {
//   PROCESSING = 1, //Tạo mới
//   APPROVED = 2, // Đã duyệt thành công để lên hđ
//   EXPIRED = 3, //Hết hạn theo config giỏ hàng
//   CANCELLED = 4, // Tự hủy
//   WAITING_FOR_UPDATE_PAYMENT_RESERVATION = 5, //Chờ bổ sung
//   UPDATEDED_PAYMENT_RESERVATION = 6, // Đã cập nhật UNC
//   CANCEL_REQUEST = 7, // Yêu cầu hủy
// }
export enum BookingApprovalTypeEnum {
  OneStep = 1, // 1 Quy trình Submit UNC
  TwoStep = 2, // 2 Quy trình Submit UNC
}
export enum BookingStatusEnum {
  PENDING = 1, // Chờ đến lượt, các booking tạo mới đều mang trại thái này
  WAITING_FOR_UPDATE_PURCHASE_UNC = 2, // Chờ cập nhật UNC đặt mua
  UPDATED_PURCHASE_UNC = 3, // Đã cập nhật UNC đặt mua || chờ duyệt UNC đặt mua
  WAITING_FOR_UPDATE_DEPOSITED_UNC = 4, // Chờ cập nhật UNC đặt chổ, sau khi (3) được duyệt || chờ duyệt UNC đặt cọc
  UPDATED_DEPOSITED_UNC = 5, // Chờ duyệt UNC đặt chỗ || Đã cập nhật UNC đặt chổ
  APPROVED_DESPOSITED_UNC = 6, // Đặt cọc || Sau khi (5) cập nhật UNC thì admin sẽ duyệt để sang 6
  CANCEL_REQUEST = 7, // Yêu cầu hủy
  CANCELLED = 8, // Đã hủy
  EXPIRED = 9, // Hết hạn
}

export enum BookingApprovalHistoryProcessTypeEnum {
  System = 1,
  Agency = 2,
  SaleAdmin = 3,
}

export enum BookingApprovalHistoryActionTypeEnum {
  PENDING = 1, // Chờ đến lượt, các booking tạo mới đều mang trại thái này
  WAITING_FOR_UPDATE_PURCHASE_UNC = 2, // Chờ cập nhật UNC đặt mua
  UPDATED_PURCHASE_UNC = 3, // Đã cập nhật UNC đặt chổ || chờ duyệt UNC đặt mua
  WAITING_FOR_UPDATE_DEPOSITED_UNC = 4, // Chờ cập nhật UNC đặt chổ, sau khi (3) được duyệt || chờ duyệt UNC đặt cọc
  UPDATED_DEPOSITED_UNC = 5, // Đã cập nhật UNC đặt chổ
  APPROVED_DESPOSITED_UNC = 6, // Sau khi (5) cập nhật UNC thì admin sẽ duyệt để sang 6
  CANCEL_REQUEST = 7, // Yêu cầu hủy
  CANCELLED = 8, // Đã hủy
  EXPIRED = 9, // Hết hạn
  REJECTED = 10, // Đã từ chối
}

export enum BookingPaymentStatusEnum {
  WAITING = 1,
  HALFPAID = 2,
  TOTALLYPAID = 3,
}

// TRADING FLOOR
export enum TradingFloorSalutationEnum {
  GRANDFATHER = 0,
  GRANDMOTHER = 1,
  AUNT = 2,
  UNCLE = 3,
  BROTHER = 4,
  SISTER = 5,
  OTHERS = 6,
}

export enum TradingFloorScaleEnum {
  FROM_1_TO_5 = 0,
  FROM_5_TO_20 = 1,
  FROM_20_TO_50 = 2,
  FROM_50_TO_250 = 3,
  FROM_OVER_250 = 4,
}

export enum TradingFloorAgencyTypeEnum {
  SAN = 0,
  DAI_LY_PP = 1,
}

export enum TradingFloorUserJobTitleEnum {
  MANAGER = 0,
  TEAM_LEADER = 1,
  SALES_EXECUTIVE = 2,
}

export enum UnitStatusInInqueueBookingEnum {
  AVAILABLE = 1,
  BOOKED = 2,
  DEPOSITED = 3,
  SOLD = 4,
}

/** Căn còn AVAILABLE mới cho phép thao tác đổi trạng thái hiển thị trên giỏ / sự kiện mở bán (đã cọc/đặt chỗ thì không). */
export function isUnitAvailableForViewStatusActions(record: {
  unit?: { status?: { id?: number | string } }
}): boolean {
  const id = record?.unit?.status?.id
  if (id === undefined || id === null || id === "") return false
  return Number(id) === UnitStatusInInqueueBookingEnum.AVAILABLE
}

export enum BookingReservationStatusEnum {
  PROCESSING = 1,
  WAITING_FOR_PAY_CONFIRMATION = 2,
  PAID = 3,
  WAITING_FOR_REFUND_CONFIRMATION = 4,
  REFUNDED = 5,
  EXPIRED = 6,
}

export enum FeedbackStatusEnum {
  SENT = 4, // Đã gửi
  IN_PROGRESS = 5, // Đang xử lý
  COMPLETED = 6, // Hoàn thành
  CANCELLED = 9, // Đã huỷ
  REOPENED = 17, // Mở lại
}
//#endregion

export enum TitleNameEnum {
  TRADING_FLOOR_STAFF = 1,
  PROJECT_DETAIL_MANAGEMENT = 2,
}

export enum CartAgencyCommissionEnum {
  Number = 1,
  Percent = 2,
}
//#region PROJECT

export enum ProjectTypeEnum {
  Apartment = 1,
  Townhouse = 2,
}

export enum ProjectAccountTypeEnum {
  CDT = 1,
}

// Stacking plan

export enum stackingPlanByEnum {
  Cart = 1,
  Project = 2,
}
// Cách tính khuyến mãi
export enum PromotionCalculationTypeEnum {
  // Giảm giá theo thứ tự
  CASCADING = 1,
  // Giảm giá cộng gộp
  ADDITIVE = 2,
}

// Tính chiết khấu
export enum DiscountSourceTypeEnum {
  // Tính trên giá trước thuế
  PRE_TAX = 1,
  // Tính trên giá sau thuế
  POST_TAX = 2,
}

export enum PromotionProgramType {
  Normal = 1,
  Special = 2,
}

//#endregion

export enum UnitProjectTypeEnum {
  Apartment = 1,
  Villa = 2,
}
//#region SIGNALR

export enum SignalRNotificationEnum {
  ReceiveUnitPricingChange = "ReceiveUnitPricingChange", // In case, update unit pricing 👌
  // => Affect to:  stackingland

  ReceiveUpdateCartProduct = "ReceiveUpdateCartProduct", // In case, insert or delete unit from cart 👌
  // => Affect to: stackingland, detail stackingland, modal create Booking

  ReceiveBookingExpired = "ReceiveBookingExpired", // In case, booking was expired by configuration 👌
  // => Affect to:  stackingland, detail stackingland, modal detail Booking

  ReceiveBookingUnitUpdate = "ReceiveBookingUnitUpdate", // In case, unit booked and cancel 👌
  // => Affect to:  stackingland, detail stackingland

  ReceiveBookingApproved = "ReceiveBookingApproved", // In case, booking has been approved 👌
  // => Affect to:  stackingland, detail stackingland, modal detail Booking

  ReceiveBookingsStatusUpdate = "ReceiveBookingsStatusUpdate",
}

//#endregion

export enum DataChangeTypeEnum {
  Delete = 1,
  Create = 2,
}

export enum ConfigPaymentScheduleSetupEnum {
  MANUAL = 1,
  FROM_CONTRACT_DATE = 2,
}

export enum ConfigPaymentScheduleSetupGenerateCalendartEnum {
  DAY_SINCE_PREVIOUS_PAYMENT = 2,
  DAY_FROM_FIRST_PAYMENT = 1,
}

export enum ConfigPaymentScheduleSetupExpiredDateEnum {
  MANUAL = 1,
  DAY = 2,
  MONTH = 3,
  FIELD = 4,
}

export enum ConfigPaymentScheduleSetupDueDateEnum {
  EVERYDAY = 1,
  SUBTRACT_HOLIDAY = 2,
}

//#region SYSTEM
export enum EmailSecurityTypeEnum {
  None = 1, //Không
  SSL_TLS = 2, //SSL/TSL
  STARTTLS = 3, //STARTTLS
}

export enum SmsProviderEnum {
  VietGuys = 1,
  VMG = 2,
  SouthTelecom = 3,
}

export enum SystemEmailTypeEnum {
  Gmail = 1, //Gmail
  Microsoft = 2, //Microsoft 365 / Exchange Online
  SendGrid = 3, //SendGrid
  Aws = 4, //AWS SES (SMTP)
}
//#endregion

export enum FeeTypeTypeEnum {
  TYPE_AUTO = 1,
  TYPE_CUSTOM = 2,
}

export enum FeeTypeUnitTypeEnum {
  PERCENT = 1,
  VND = 2,
}

export enum FeeVariableTypeEnum {
  SYSTEM = 1,
  CUSTOM = 2,
}

export enum FeeTypeCodeConstEnum {
  SP = "SP",
  MAINTAIN = "MAINTAIN",
}

export enum ConfigPaymentScheduleSetupDateFromContractEnum {
  ValidDate = 1,
  DADate = 2,
  SPAOrLTLDate = 3,
}

export enum PaymentRequestTypeEnum {
  InCome = 1,
  OutCome = 2,
}

export enum FlowType {
  Sequential = 1,
  Parallel = 2,
}

export enum ConditionType {
  One = 1,
  All = 2,
}

export enum AgencyUserTypeEnum {
  Staff = 1,
  Manager = 2,
}

export enum AgencyGroupUserRole {
  Staff = 1,
  Manager = 2,
}

export enum StaffRoleEnum {
  L0 = 'Owner', //Owner (cấp cao nhất)
  L1 = 'Sales Admin', //Sales Admin
  L2 = 'Area Sales Director', //Area Sales Director
  L3 = 'Sales Director', //Sales Director
  L4 = 'Sales Staff', //Sales Staff
}

export enum CartComissionTypeEnum {
  ByCart = 1,
  ByProduct = 2,
}

export enum BookingTypeToast {
  BOOKING_NEED_APPROVAL = 1, // 1: (bạn có đặt chổ cần duyệt), nhận: Quản lí giỏ hàng
  BOOKING_NEED_CANCEL = 2, // 2: (bạn có đặt chổ yêu cầu hủy), nhận: Quản lí giỏ hàng
  BOOKING_NEED_SUBMIT_UCN = 3, // 3: (bạn có đặt chổ cần submit UNC), nhận: Người tạo Booking + Quản lí sàn
  BOOKING_NEED_REJECT = 4, // 4: (Bạn có đặt chổ bị từ chối/hủy), nhận: Người tạo Booking + Quản lí sàn
  BOOKING_NEED_APPROVED_V2 = 5, // 5: (Bạn có đặt chổ đã được duyệt), nhận: Người tạo Booking + Quản lí sàn
}

interface Option {
  id?: number
  value: number
  label: string
  enum?: string
}

export enum FeedbackSourceEnum {
 
  CALLCENTER = 1,
  MOBILE = 2,
  MAIL = 3,
  OFFICE = 4,
  WEB = 5,
  OTHERS = 6,
}

export enum DialogResponseMessageType {
  SUCCESS = 0, // Thành công
  BOOKINGISPICKED = 1, // Booking đã chọn sản phẩm khác  
  PRODUCTISPICKED = 2, // Sản phẩm đã được chọn trước đó
  SALESEVENTISEXPIRED = 3, // SỰ kiện đã hết hạn 
  PICKPRODUCTOVERLIMIT = 4, // Booking đã hết lượt chọn sản phẩm 
  QUOTALIMITEXHAUSTED = 5,  // Hết hạn mức quota
}

export function getOptionsFromEnum<T>(
  enumObj: any,
  translationPrefix?: string
): Option[] {
  const res = Object.keys(enumObj)
    .filter((key) => isNaN(Number(key)))
    .map((key) => ({
      id: enumObj[key as keyof T],
      value: enumObj[key as keyof T],
      label: L(`${translationPrefix ?? ""}_${key.toUpperCase()}`),
      enum: key,
    }))
  return res
}
